import { ReactNode } from 'react'

import { IconName } from '../Icon'
import { useDialog } from './context'

import * as SC from './styles'

type Props = {
  title?: string
  subTitle?: string
  action?: ReactNode
}

export const DialogHeader = (props: Props) => {
  const { title, subTitle, action } = props

  const dialog = useDialog()

  return (
    <SC.Header>
      <SC.HeaderLeft>
        {subTitle && <SC.HeaderSubTitle data-testid="subtitle">{subTitle}</SC.HeaderSubTitle>}
        {title && <SC.HeaderTitle data-testid="title">{title}</SC.HeaderTitle>}
      </SC.HeaderLeft>
      {action && <SC.HeaderAction data-testid="action">{action}</SC.HeaderAction>}
      {!action && <SC.CloseIcon name={IconName.CLEAR} data-testid="close" onClick={() => dialog.close()} />}
    </SC.Header>
  )
}
